import { render, staticRenderFns } from "./RequestPickup.vue?vue&type=template&id=6b4affbe&scoped=true&"
import script from "./RequestPickup.vue?vue&type=script&lang=js&"
export * from "./RequestPickup.vue?vue&type=script&lang=js&"
import style0 from "./RequestPickup.vue?vue&type=style&index=0&id=6b4affbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4affbe",
  null
  
)

export default component.exports